<template>
    <div class="sc-message--text">
        <l-map ref="map" @ready="ready" :center="message.raw.location" :zoom="zoom" class="map" @click="openGoogleMaps">
            <l-tile-layer :url="url" />
            <l-marker :icon="icons.default" :lat-lng="message.raw.location" />
        </l-map>
    </div>
</template>

<script>
import L from "leaflet";

export default {
    name: "LocationMessage",
    props: {
        message: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            zoom: 15,
            icons: {
                default: L.icon({
                    iconUrl: "https://img.icons8.com/ios-glyphs/30/undefined/marker--v1.png",
                    iconSize: [34, 34],
                    iconAnchor: [17, 17],
                }),
            },
        };
    },
    methods: {
        ready() {
            if (!!this.$refs.map) {
                setTimeout(() => {
                    if (this.$refs.map) {
                        this.$refs.map.mapObject["invalidateSize"]();
                    }
                }, 300);
            }
        },
        openGoogleMaps() {
            window.open(
                `https://www.google.com/maps/search/?api=1&query=${this.message.raw.location.lat},${this.message.raw.location.lng}`,
                "_blank"
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.map {
    height: 170px;
    width: 280px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0 3px #00000057;
}
</style>
